import BasicDomain from "./BasicDomain";
import * as yup from 'yup';

export default class Location extends BasicDomain {
    static DEFAULTS = {
        label: '',
        parent: null,
        coordinates: null,
        events: [],
        isCentroid: false
    }

    static FIELDS = [
        { field: 'label', label: 'Label', type: 'String' },
        { field: 'parent', label: 'Parent Location', type: { type: 'Pointer', targetClass: 'Location' } },
        { field: 'coordinates', label: 'Coordinates', type: 'GeoPoint' },
        { field: 'isCentroid', label: 'Is Centroid', type: 'Boolean' }
    ];
  
    static VALIDATION_SCHEMA = yup.object().shape({
        label: yup.string().required('Label is required'),
        coordinates: yup.object().shape({
            latitude: yup.number()
                .min(-90, 'Latitude must be between -90 and 90')
                .max(90, 'Latitude must be between -90 and 90')
                .required('Latitude is required'),
            longitude: yup.number()
                .min(-180, 'Longitude must be between -180 and 180')
                .max(180, 'Longitude must be between -180 and 180')
                .required('Longitude is required')
        }).required('Coordinates are required')
    });

    constructor(props) {
        super('Location', props, Location.DEFAULTS);
    }

    inspect = () => {
        return Location.VALIDATION_SCHEMA.validate(this, { abortEarly: false });
    }
}